import React from 'react';
import { Empty, Scrollbar, theme } from 'codeArt/components/Base';
import { BarChart } from './common';
import ReactEcharts from "echarts-for-react";

export class FinishedNumber extends BarChart {

    constructor(props) {
        super(props);
        this.title = "";
    }

    getY() {
        let { data } = this.props;

        let max = 0;
        data.forEach((t) => {
            if (t.value > max) max = t.value;
        });

        max = parseInt((max + parseInt(max / 3)) / 10) * 10;
        max = (parseInt(max / 1000)) * 1000;
        return {
            min: 0, max: max, interval: 1000,
            splitLine: { show: true, lineStyle: { type: "solid", color: "#f0f0f0" } }
        };
    }

    getX() {
        return {
            axisLabel: { interval: 0 }
        };
    }


    getGrid() {
        return { left: 25, right: 30, bottom: 0, top: 50 };
    }
}


export class FinishedPrecent extends React.Component {

    constructor(props) {
        super(props);
    }

    labelFormat(params) {
        let { data } = this.props;
        let name = params.name;
        let value = params.value;
        let item = data.find(t => { return t.name == name; }) || {};

        value = item.format ? item.format(value) : `${value}%`;

        return { name, value };
    }

    getOption() {

        let { data } = this.props;

        let option = {};
        let my = this;

        option = {
            tooltip: {
                trigger: 'item',
                formatter: function (params) {
                    let { name, value } = my.labelFormat(params);
                    let tip = `${name} : ${value}`;
                    return tip;
                }
            },
            legend: {
                orient: 'horizontal',
                left: 'center',
            },
            series: {
                type: 'pie',
                radius: '50%',
                data: data,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        }

        let label = {
            formatter: function (params) {
                let { name, value } = my.labelFormat(params);
                let tip = `  {b|${name}：}{per|${value}}  `;
                return tip;
            },
            rich: {
                b: {
                    fontSize: 15,
                    lineHeight: 30
                },
                per: {
                    color: "#eee",
                    backgroundColor: "#334455",
                    padding: [2, 4],
                    borderRadius: 2
                }
            }
        };
        label.backgroundColor = "#eee";
        label.borderColor = "#aaa";
        label.borderWidth = 1;
        label.borderRadius = 4;
        option.series.label = label;

        option.grid = { left: "10", right: "10", bottom: "10", top: "0"};

        return option;

    };

    render() {
        return <ReactEcharts option={this.getOption()} notMerge={true} lazyUpdate={true} className={"w-100 h-100"} />
    }
}